export default "__VITE_ASSET__B$mO9SLu__"